/**
 * Action for listing notifications.
 *
 * @class
 */
Sitepackage.Plugin.Notification.ListAction = (function () {
    /**
     * Initializes the action.
     *
     * @param {Notification} plugin Parent plugin
     * @param {Element} pluginContainer Parent plugin container
     * @param {Element} container Main container of the action
     *
     * @constructor
     */
    var ListAction = function (plugin, pluginContainer, container) {
        const self = this;

        // Parent plugin
        this.plugin = plugin;

        // Parent plugin container
        this.pluginContainer = pluginContainer;

        // Main container of the action
        this.container = container;

        var notificationCountElement = pluginContainer.querySelector('[data-notificationcount]');
        notificationCountElement.classList.add('d-none');

        //Request new notifications once
        this.requestNotifications(self);

        //the request new notifications every minute
        setInterval(function () {
            self.requestNotifications(self)
        }, 60000);

    };

    /**
     * Loads notifications for the current user
     *
     * @returns {void}
     */
    ListAction.prototype.requestNotifications = function (plugin) {

        GeneralUtility.ajaxGetRequest(GeneralUtility.getAjaxUrl('notification-list'), function (data) {
            var notificationList = plugin.container.querySelector('[data-notificationlist]');
            if (notificationList) {
                notificationList.innerHTML = data;
            }

            var toasts = document.querySelectorAll('[data-dismiss="toast"]');
            if (toasts) {
                toasts.forEach(function (toast) {
                    var toastEl = new Toast(toast, {
                        autohide: false
                    });
                    toastEl.show();
                    toast.closest('.toast').addEventListener('hidden.bs.toast', function (event) {
                        plugin.markNotificationAsRead(plugin, event.target.dataset.uid);
                    }, false);
                    toast.closest('.toast').querySelector('.notification-close').addEventListener('click', function (event) {
                        plugin.markNotificationAsRead(plugin, event.target.closest('.toast').dataset.uid);
                    }, false);
                });
            }

            var notificationCountElement = plugin.container.querySelector('[data-notificationcount]');
            var totalNotificationCountElement = plugin.container.querySelector('[data-total]');
            if (notificationCountElement && totalNotificationCountElement) {

                notificationCountElement.innerHTML = totalNotificationCountElement.dataset.total;
                if (parseInt(totalNotificationCountElement.dataset.total) === 0) {
                    notificationCountElement.classList.add('d-none');
                } else {
                    notificationCountElement.classList.remove('d-none');
                }
            }

            if (plugin.container.querySelectorAll('[data-toggle="tooltip"]')) {
                plugin.container.querySelectorAll('[data-toggle="tooltip"]').forEach(function (tooltip) {
                    new Tooltip(tooltip);
                });
            }
        });

    };

    /**
     * Marks a single notification as read and then reload notification list and count
     *
     * @returns {void}
     */
    ListAction.prototype.markNotificationAsRead = function (plugin, notificationId) {
        var url = GeneralUtility.getAjaxUrl('notification-read');
        url = GeneralUtility.appendUrlParameter(url, 'notificationId', notificationId);
        var notificationElement = plugin.container.querySelector('#notification-' + notificationId);
        anime({
            targets: notificationElement,
            opacity: 0,
            duration: 300,
            easing: 'linear',
            complete: function (anim) {
                anime({
                    targets: notificationElement,
                    height: 0,
                    duration: 300,
                    easing: 'linear',
                    complete: function (anim) {
                        notificationElement.remove();
                    }
                });
            }
        });
        var notificationCountElement = plugin.container.querySelector('[data-notificationcount]');
        notificationCountElement.innerHTML = (parseInt(notificationCountElement.innerHTML) - 1);
        GeneralUtility.ajaxGetRequest(url, function () {
            if (parseInt(notificationCountElement.innerHTML) === 0) {
                plugin.requestNotifications(plugin);
            }
        });

    };

    return ListAction;
})();
